import React from 'react';
import {IEmbedAppModel} from './model/appModel';
import {QueryParamProvider} from 'use-query-params';
import config from './service/config';
import './static/css/index-embed.less';
import StateProvider, {PWCEntryPoint} from './context/stateProvider';
import {BrowserRouter} from 'react-router-dom';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import Embed from './component/display/Embed';
import {createGlobalStyle} from 'styled-components';
import {ReactRouter5Adapter} from 'use-query-params/adapters/react-router-5';
import {createRoot} from 'react-dom/client';

const EmbedGlobalStyle = createGlobalStyle`
   #embed-root {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
   }
`;

export default (model: IEmbedAppModel) => {
   const embedRoot = document.getElementById('embed-root');
   if (!embedRoot) {
      return;
   }

   document.body.classList.add('app-body');

   config.initEmbed(model);

   createRoot(embedRoot).render(
      <DndProvider backend={HTML5Backend}>
         <EmbedGlobalStyle />
         <BrowserRouter>
            <QueryParamProvider adapter={ReactRouter5Adapter}>
               <StateProvider entryPoint={PWCEntryPoint.Embed}>
                  <Embed mediaDetails={config.embedConfig.media} />
               </StateProvider>
            </QueryParamProvider>
         </BrowserRouter>
      </DndProvider>
   );
};
